import React, { useMemo, useEffect, useRef } from "react";
import cx from "classnames";
import { Modal as BaseModal } from "react-overlays";

import Dialog from "./Dialog";

import ModalTransition from "./ModalTransition";
import ModalBackgroundTransition from "./ModalBackgroundTransition";

import ModalContext from "./ModalContext";
import styles from "./Modal.module.css";

const Modal = (props) => {
  const {
    baseClassName,
    className,
    style,
    backdrop,
    backdropClassName,
    backdropBaseClassName,
    backdropStyle,
    flex,
    show,
    onHide,
    onExited,
    enforceFocus,
    verticalPad,
    children,
    onReturn,
  } = props;

  const dialogRef = useRef();

  const onBackgroundClick = (e) => {
    if (e.currentTarget === e.target && onHide && backdrop === true) {
      e.stopPropagation();
      onHide();
    }
  };

  const handleKeyDown = (e) => {
    switch (e.key) {
      case "Escape":
        if (onHide) onHide();
        break;
      case "Enter":
        if (onReturn) onReturn();
        break;
      default:
        break;
    }
  };

  const verticalPadOverride = verticalPad ? { paddingTop: verticalPad } : {};

  const providerValue = useMemo(() => ({ onHide }), [onHide]);

  // Handling logic to make modals use popover api
  // @todo: popover should be on baseModal and not it's child
  useEffect(() => {
    if (!show) return () => {};

    if (dialogRef?.current?.showPopover) {
      dialogRef.current.showPopover();
    }

    return () => {
      if (dialogRef?.current?.hidePopover) {
        dialogRef.current.hidePopover();
      }
    };
  }, [show]);

  return (
    <ModalContext.Provider value={providerValue}>
      <BaseModal
        show={show}
        onHide={onHide}
        onExited={onExited}
        className={cx(baseClassName, className)}
        style={style}
        enforceFocus={enforceFocus}
        backdrop={backdrop}
        renderBackdrop={(renderProps) => (
          <div
            className={cx(backdropBaseClassName, backdropClassName)}
            style={backdropStyle}
            {...renderProps}
          />
        )}
        backdropTransition={ModalBackgroundTransition}
        transition={ModalTransition}
        onKeyDown={handleKeyDown}
      >
        <div
          ref={dialogRef}
          popover="manual"
          className={`${baseClassName} __dialog`}
          style={verticalPadOverride}
        >
          {backdrop && onHide ? (
            <div
              style={{ width: "100%", height: "100%", position: "absolute", top: 0, left: 0 }}
              onClick={onBackgroundClick}
            />
          ) : null}
          {children}
        </div>
      </BaseModal>
    </ModalContext.Provider>
  );
};

Modal.defaultProps = {
  enforceFocus: true,
  baseClassName: "si-c-modal",
  backdropBaseClassName: "si-c-modal__backdrop",
  backdrop: true,
};

Modal.Dialog = Dialog;
Modal.BASIC_PROPS = ["show", "onHide", "onExited", "container"];

export default Modal;
